import React, { useState } from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import { Trans, useTranslation } from 'react-i18next';
import { UploadToDelete } from '@api/upload/dto/UploadToDelete';
import useDeleteUpload from '@api/upload/hooks/useDeleteUpload';

type Props = {
  uploadToDelete: UploadToDelete;
  rendered: boolean;
  triggerUploadsTableRefresh: (uploadsTableRefresh: boolean) => void;
};

function DeleteOption({ uploadToDelete, rendered, triggerUploadsTableRefresh }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const deleteUpload = useDeleteUpload(triggerUploadsTableRefresh);

  const onSubmit = () => {
    setIsSubmitting(true);
    setOpen(false);
    deleteUpload(uploadToDelete);
  };

  const onClose = () => {
    setOpen(false);
  };

  if (!rendered) {
    return null;
  }

  return (
    <Modal
      as={Form}
      onSubmit={onSubmit}
      closeIcon
      onClose={onClose}
      onOpen={() => {
        setIsSubmitting(false);
        setOpen(true);
      }}
      open={open}
      trigger={<Button icon="trash alternate outline" negative size="tiny" />}
    >
      <Modal.Header>{t('upload.delete.modal.title')}</Modal.Header>
      <Modal.Content>
        <Trans
          defaults="upload.delete.modal.confirmation"
          values={{ uploadName: uploadToDelete.name }}
          components={{ italic: <i />, bold: <strong /> }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>{t('button.cancel')}</Button>
        <Button
          type="submit"
          content={t('button.ok')}
          labelPosition="right"
          icon="checkmark"
          positive
          disabled={isSubmitting}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default DeleteOption;
